export type UpgradeTeamsBadgeProps = {
  checkForActiveStatus?: boolean;
  hasPaidPlan?: boolean;
  hasActiveTeamPlan?: boolean;
  isTrial?: boolean;
};

export const UpgradeTeamsBadge = function UpgradeTeamsBadge(_props: UpgradeTeamsBadgeProps) {
  return null;
};
